import { render, staticRenderFns } from "./addAiOrderConfig.vue?vue&type=template&id=2262e828&scoped=true&"
import script from "./addAiOrderConfig.vue?vue&type=script&lang=js&"
export * from "./addAiOrderConfig.vue?vue&type=script&lang=js&"
import style0 from "./addAiOrderConfig.vue?vue&type=style&index=0&id=2262e828&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2262e828",
  null
  
)

export default component.exports